import moment from 'moment';

const setting = {
  /**
   * 文件大小转换
   */
  getFileSize: (fileByte) => {
    const fileSizeByte = fileByte;
    let fileSizeMsg = '';
    if (fileSizeByte < 1048576) fileSizeMsg = `${(fileSizeByte / 1024).toFixed(2)}KB`;
    else if (fileSizeByte == 1048576) fileSizeMsg = '1MB';
    else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) fileSizeMsg = `${(fileSizeByte / (1024 * 1024)).toFixed(2)}MB`;
    else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824) fileSizeMsg = '1GB';
    else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) fileSizeMsg = `${(fileSizeByte / (1024 * 1024 * 1024)).toFixed(2)}GB`;
    else fileSizeMsg = '文件超过1TB';
    return fileSizeMsg;
  },
  /**
   * 转换时分秒
   */
  setTime: (time) => {
    const tempTime = moment.duration(Number(time), 'seconds');
    const day = tempTime.days() < 10 ? `0${tempTime.days()}` : tempTime.days();
    const hour = tempTime.hours() < 10 ? `0${tempTime.hours()}` : tempTime.hours();
    const min = tempTime.minutes() < 10 ? `0${tempTime.minutes()}` : tempTime.minutes();
    const sec = tempTime.seconds() < 10 ? `0${tempTime.seconds()}` : tempTime.seconds();
    const hourNoDay = (tempTime.days() * 24) + tempTime.hours();
    const hourTime = hourNoDay < 10 ? `0${hourNoDay}` : hourNoDay;
    return { day, hour, min, sec, hourTime }; // 返回时分秒
  },
  /**
   * 判断pc移动端
   */
  core: () => {
    const sUserAgent = navigator.userAgent.toLowerCase();
    const bIsIpad = sUserAgent.match(/ipad/i) == 'ipad';
    const bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os';
    const bIsMidp = sUserAgent.match(/midp/i) == 'midp';
    const bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4';
    const bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb';
    const bIsAndroid = sUserAgent.match(/android/i) == 'android';
    const bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce';
    const bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile';
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
      return 'h5';
    }
    return 'pc';
  },
  toDecimal: (x, y) => {
    let f = parseFloat(x);
    if (isNaN(f)) {
      return false;
    }
    f = Math.round(x * 100) / 100;
    let s = f.toString();
    let rs = s.indexOf('.');
    if (rs < 0) {
      rs = s.length;
      s += '.';
    }
    while (s.length <= rs + y) {
      s += '0';
    }
    return s;
  },
  // 下载保存文档
  saveAs: (blob, filename) => {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      const body = document.querySelector('body');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      // fix Firefox
      link.style.display = 'none';
      body.appendChild(link);
      link.click();
      body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    }
  },
};

export default setting;



// WEBPACK FOOTER //
// ./src/utils/setting.js